module.exports = vendor;


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 76
// module chunks = 0